import { atom } from "jotai";

import type { Props } from "~/components/advertisement/ad-slots/ad-slot";

export type HeaderAdSlotSpec = Pick<Props, "adUnit" | "targeting" | "zone">;

export type State = {
  desktop: HeaderAdSlotSpec | null;
  mobile: HeaderAdSlotSpec | null;
} | null;

export const appBarAdSlotAtom = atom<State>(null);
